export default __webpack_public_path__ + "static/media/grid5.7d59a386.png";